import { identify, makeRequest, Service } from '../../../utils/http';

type Data = {
  id: string;
};

export async function getClientProjectsApi({ id }: Data) {
  return makeRequest(Service.getClientProjects(id, await identify()));
}
